import classnames from 'classnames'
import moment from 'moment'
import React from 'react'
import css from './totalSales.css'
import { BudgetItem } from './TotalSalesTable'
import { TotalSalesNote } from './types'
type Props = {
  data: BudgetItem
  handleSelectNote: (note: TotalSalesNote) => void
}

const TotalSalesRow = ({ data, handleSelectNote }: Props) => {
  const difference = data.totalSales - data.budget
  const differenceToLastYear = data.totalSales - data.totalSalesLastYear
  return (
    <tr className={css.dayRow}>
      <td>{moment(data.date).format('D.M - dd')}</td>
      <td>{data.budget}</td>
      <td>{data.totalSales}</td>
      <td
        className={classnames({
          [css.negativeDifference]: difference < 0,
          [css.positiveDifference]: difference > 0,
        })}
      >
        {data.totalSales === 0 ? '-' : difference}
      </td>
      <td
        className={classnames({
          [css.negativeDifference]: differenceToLastYear < 0,
          [css.positiveDifference]: differenceToLastYear > 0,
        })}
      >
        {data.totalSales === 0 ? '-' : differenceToLastYear}
      </td>
      <td>
        <p
          onClick={() =>
            handleSelectNote({
              date: data.date,
              notes: data.note,
            })
          }
          className={css.notes}
        >
          {data.note}
        </p>
      </td>
    </tr>
  )
}

export default TotalSalesRow
